import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const useAuthErrorHandler = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Создаем интерцептор для ответов
    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        // Проверяем на ошибки авторизации в формате вашего API
        if (response.data.result === 0 && 
           (response.data.resultCode === 's151' || response.data.resultCode === 's152')) {
          // s151 - не авторизован, s152 - токен истек
          handleAuthError();
          window.location.reload();
        }
        return response;
      },
      (error) => {
        // Проверяем на HTTP 401 или 403 ошибки авторизации в data
        if (error.response?.status === 401 || error.response?.status === 403 ||
           (error.code === 's151' || error.code === 's152')) {
          handleAuthError();
        }
        return Promise.reject(error);
      }
    );

    const handleAuthError = async () => {
      console.log('Обнаружена ошибка авторизации, обновляем состояние...');
      
      // Очищаем localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("session");
      localStorage.removeItem("loginHash");
      localStorage.removeItem("codeHash");
      localStorage.removeItem("typeAuth");
      localStorage.removeItem("cart");
      localStorage.removeItem("check");
      sessionStorage.clear();

      // Обновляем Redux состояние
      try {
        const { logout } = await import('../redux/reducer/slices/profileSlice');
        dispatch(logout());
      } catch (error) {
        console.error('Ошибка при вызове logout:', error);
      }
    };

    // Очистка интерцептора при размонтировании компонента
    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [dispatch]);
};

export default useAuthErrorHandler;
